import InputNumber from "../frontv2/InputNumber";

const initInputNumber = () => {
  const allInputNumber = document.querySelectorAll('div.input-number');
  if (allInputNumber.length > 0) {
    allInputNumber.forEach((wrapperInputNumber) => {
      new InputNumber(wrapperInputNumber);
    });
  }
}

export {initInputNumber}
